var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSociallinkYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "33px",
    viewBox: "0 0 46 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "yt_icon_mono_dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "5.9505531e-16 0 46 0 46 33 5.9505531e-16 33"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicle-buy-cash-/-personal-info",
    transform: "translate(-949.000000, -1969.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "yt_icon_mono_dark",
    transform: "translate(949.000000, 1969.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2954545,23.4643306 L18.2954545,9.53566935 L30.3181818,16.5002661 L18.2954545,23.4643306 Z M45.0387045,5.15305645 C44.5097045,3.12462097 42.9509318,1.52731452 40.9718864,0.985209677 C37.3846705,0 23,0 23,0 C23,0 8.61532955,0 5.02811364,0.985209677 C3.04906818,1.52731452 1.49029545,3.12462097 0.961295455,5.15305645 C0,8.8293629 0,16.5 0,16.5 C0,16.5 0,24.170371 0.961295455,27.8469435 C1.49029545,29.875379 3.04906818,31.4726855 5.02811364,32.0150565 C8.61532955,33 23,33 23,33 C23,33 37.3846705,33 40.9718864,32.0150565 C42.9509318,31.4726855 44.5097045,29.875379 45.0387045,27.8469435 C46,24.170371 46,16.5 46,16.5 C46,16.5 46,8.8293629 45.0387045,5.15305645 L45.0387045,5.15305645 Z",
    id: "Fill-1",
    fill: "#FFFFFE",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociallinkYoutube);
export default __webpack_public_path__ + "static/media/sociallink_youtube.d095e9f45121af0ac15d366c6955e0ce.svg";
export { ForwardRef as ReactComponent };